import script from "./UploadFolders.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadFolders.vue?vue&type=script&setup=true&lang=js"

import "./UploadFolders.vue?vue&type=style&index=0&id=2daa6371&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2daa6371"]])

export default __exports__